// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CT1d","content":"styles_content__o5EvF","row":"styles_row__3LmsH","footer":"styles_footer__1FHyl","phraseLength":"styles_phraseLength__3a4TD"};